import { instance } from "@/service/api";

/**
 * API Service สำหรับ Notification
 * ใช้ Axios instance (instance) ที่มี Token interceptor และ Base URL พร้อมอยู่แล้ว
 */

/**
 * ดึงรายการแจ้งเตือนของตนเองพร้อม unreadCount
 */
export const fetchNotifications = () => instance.get("/notifications");

/**
 * นับจำนวน Unread Badge เท่านั้น (lightweight)
 */
export const fetchUnreadCount = () => instance.get("/notifications/unread-count");

/**
 * อ่านแจ้งเตือนทีละรายการ
 * @param {string} id - notification ObjectId
 */
export const markOneRead = (id) => instance.patch(`/notifications/${id}/read`);

/**
 * อ่านทั้งหมดของตนเอง
 */
export const markAllRead = () => instance.patch("/notifications/read-all");

/**
 * ล้างรายการที่อ่านแล้วทั้งหมดของตนเอง
 */
export const clearReadNotificationsApi = () => instance.delete("/notifications/clear-read");

/**
 * ลบแจ้งเตือนรายการเดียว
 * @param {string} id - notification ObjectId
 */
export const deleteNotificationApi = (id) => instance.delete(`/notifications/${id}`);


